import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { FlashMessage } from '@/types/flashMessage';
import { sentryReportError } from '@/utils/sentryReportError';

export const handleError = (
  setFlashMessage: (message: FlashMessage) => void,
  err: any,
) => {
  if (
    err.response &&
    err.response.status === 401 &&
    err.response.data &&
    err.response.data.error === constants.INVALID_ACCESS_TOKEN_ERROR
  ) {
    setFlashMessage({
      body: i18n.t('ui.error.unexpected_and_login'),
      isWarning: true,
    });
  } else {
    sentryReportError(err);

    setFlashMessage({
      body: i18n.t('ui.error.unexpected'),
      isWarning: true,
    });
  }
};
